const searchType = Object.freeze({
  PUBLISHER: 1,
  GET_THROUGH: 2,
})

const targets = Object.freeze({
  1: '単語',
  2: '連語',
  3: '既習語',
})

const questionTypeText = Object.freeze({
  1: '見出し(単語)',
  2: '見出し(連語)',
  3: '例文(単語)',
  4: '例文(連語)',
  5: '活用語',
  6: '反意語（単語）',
  7: '反意語（連語）',
})

const sortTypeText = Object.freeze({
  1: {
    1: 'ページ順',
    2: 'ランダム'
  },
  2: {
    1: '見出し順',
    2: 'ランダム'
  }
})
const descriptionType = Object.freeze({
  1: 'あり',
  2: 'なし',
})


export default Object.freeze({
  searchType: searchType,
  targets: targets,
  questionTypeText: questionTypeText,
  sortTypeText: sortTypeText,
  descriptionType: descriptionType,
})
